export default "__VITE_ASSET__n3r$9DTG__"